import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Layers from "../../../layers/Layers";
import { SelectBoxConfig, SelectBoxItem } from "../../../types/Interface";
import SelectBoxFactory from "./SelectBoxFactory";
import MoveAnimation from "../../../animation/MoveAnimation";
import addInteractivity from "../../../utils/addInteractivity";
import { CustomCursorType } from "../CustomCursor/CustomCursor";


export default class SelectBox extends PIXI.Container {
  private Layers = Layers.getInstance();
  private items!: SelectBoxItem[];
  private selectedItemIndex!: number;
  private config!: SelectBoxConfig;
  private arrow = new PIXI.Graphics();
  private SelectBoxMainCon = new PIXI.Container();
  private SelectBoxCon = new PIXI.Container();
  private SelectBoxItemCon = new PIXI.Container();
  private defaultSBICY!: number;

  constructor(items: SelectBoxItem[], selectedItemIndex: number, config: SelectBoxConfig) {
    super();
    this.items = items;
    this.selectedItemIndex = selectedItemIndex;
    this.config = config;
    this.defaultSBICY = -(this.config.height * this.items.length + 10);
    this.addSelectBoxItem(this.items[this.selectedItemIndex]);
    this.addContainers();
    this.addList();
    this.addMask();
    this.addToLayer();
  }
  private addContainers() {
    this.SelectBoxMainCon.addChild(this.SelectBoxItemCon, this.SelectBoxCon);
    this.SelectBoxItemCon.y = this.defaultSBICY;
    this.addChild(this.SelectBoxMainCon);
  }
  private addToLayer = () => this.Layers.UI.addChild(this);
  private addList = () => this.items.forEach((item, index) => this.addSelectBoxItem(item, index + 1));
  private addMask = () => this.SelectBoxMainCon.mask = this.addChild(SelectBoxFactory.genMask(this.config, this.items.length));

  addSelectBoxItem(sbItem: SelectBoxItem, index?: number) {
    let con: PIXI.Container = index ? this.SelectBoxItemCon : this.SelectBoxCon;
    const label = index ? sbItem.label : this.config.header ? this.config.header : sbItem.label;
    const item = con.addChild(SelectBoxFactory.genItemCon(this.config, label, index));

    if (!index) {
      SelectBoxFactory.genArrow(this.arrow, this.config, "up");
      con.addChild(this.arrow);
    }
    const handleDownFunc = () => {
      if (!index) {
        let target = this.defaultSBICY;
        if (this.SelectBoxItemCon.y == this.defaultSBICY) {
          target = this.config.y + 20;
          SelectBoxFactory.genArrow(this.arrow, this.config, "down");
        } else {
          this.defaultSBICY;
          SelectBoxFactory.genArrow(this.arrow, this.config, "up");
        }

        new MoveAnimation(this.SelectBoxItemCon, { "y": target }, 800, Tween.Easing.Quadratic.Out);
      }
      else if (index != this.selectedItemIndex + 1) sbItem.onHandle();
    }
    addInteractivity(item, { handleDownFunc }, CustomCursorType.pointer);
  }
}